<div [formGroup]="control">
  <evc-quote-technical-details-intro
    *ngIf="activeStep === technicalDetailsSteps.intro"
    (formReady)="goToStep(technicalDetailsSteps.fuseBox)"
    (continueLater)="continueLater($event)"
    (goBack)="navigateBack()"
  ></evc-quote-technical-details-intro>

  <evc-quote-technical-details-continue-later
    *ngIf="activeStep === technicalDetailsSteps.continueLater"
    [email]="email"
    (resend)="continueLater(previousScreen)"
    (goBack)="goToStep(previousScreen)"
  ></evc-quote-technical-details-continue-later>

  <evc-quote-technical-details-fuse-box
    *ngIf="activeStep === technicalDetailsSteps.fuseBox"
    formControlName="fuseBox"
    (formReady)="goToStep(technicalDetailsSteps.electricPhase)"
    (continueLater)="continueLater($event)"
    (goBack)="goToStep(technicalDetailsSteps.intro)"
  ></evc-quote-technical-details-fuse-box>

  <evc-quote-technical-details-electric-phase
    *ngIf="activeStep === technicalDetailsSteps.electricPhase"
    formControlName="electricPhase"
    (formReady)="goToStep(technicalDetailsSteps.mainFuse)"
    (goBack)="goToStep(technicalDetailsSteps.fuseBox)"
  ></evc-quote-technical-details-electric-phase>

  <evc-quote-technical-details-main-fuse
    *ngIf="activeStep === technicalDetailsSteps.mainFuse"
    formControlName="mainFuse"
    (formReady)="goToStep(technicalDetailsSteps.placement)"
    (continueLater)="continueLater($event)"
    (goBack)="goToStep(technicalDetailsSteps.electricPhase)"
  ></evc-quote-technical-details-main-fuse>

  <evc-quote-technical-details-placement
    *ngIf="activeStep === technicalDetailsSteps.placement"
    formControlName="placement"
    (formReady)="goToStep(technicalDetailsSteps.distance)"
    (continueLater)="continueLater($event)"
    (goBack)="goToStep(technicalDetailsSteps.mainFuse)"
  ></evc-quote-technical-details-placement>

  <evc-quote-technical-details-distance
    *ngIf="activeStep === technicalDetailsSteps.distance"
    formControlName="distance"
    (formReady)="goToStep(technicalDetailsSteps.trajectory)"
    (goBack)="goToStep(technicalDetailsSteps.placement)"
  ></evc-quote-technical-details-distance>

  <evc-quote-technical-details-trajectory
    *ngIf="activeStep === technicalDetailsSteps.trajectory"
    formControlName="trajectory"
    (formReady)="navigate()"
    (continueLater)="continueLater($event)"
    (goBack)="goToStep(technicalDetailsSteps.distance)"
  ></evc-quote-technical-details-trajectory>
</div>
